import { getFundingProgramProperties } from "@outschool/funding-programs-shared";
import { useFundingProgramAbbr, useSession } from "@outschool/ui-auth";
import { useNavigation } from "@outschool/ui-utils";
import { useCallback } from "react";
import { useLocation } from "react-router";

type UseConcierge = {
  canAccessConcierge: boolean;
  closeConciergeModal: () => void;
};

export default function useConcierge(): UseConcierge {
  const { currentUser, isLoggedIn } = useSession();
  const navigate = useNavigation();
  const location = useLocation();

  const esaState = useFundingProgramAbbr();
  const fundingProgramProperties = getFundingProgramProperties(esaState);
  const isClassWalletProgram = fundingProgramProperties?.isClassWallet;

  const canAccessConcierge =
    isLoggedIn &&
    (currentUser?.hasSubscription ||
      currentUser?.hasEsaMembership ||
      isClassWalletProgram);

  const closeConciergeModal = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete("openConcierge");
    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true
    });
  }, [location.search, location.pathname, navigate]);

  return {
    canAccessConcierge: !!canAccessConcierge,
    closeConciergeModal
  };
}
